import React from 'react'
import DashboardMenuIcon from './assets/icons/DashboardMenuIcon.png'
import { CImage, CNavItem, CNavGroup } from '@coreui/react-pro'

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/',
    icon: <CImage fluid src={DashboardMenuIcon} className='me-2' />,
    roles: [1, 2]
  },
  {
    component: CNavItem,
    name: 'Game',
    to: '/game/list',
    icon: <CImage fluid src={DashboardMenuIcon} className='me-2' />,
    roles: [1, 2]
  },
  {
    component: CNavItem,
    name: 'Game Voucher',
    to: '/game-voucher/list',
    icon: <CImage fluid src={DashboardMenuIcon} className='me-2' />,
    roles: [1, 2]
  },
  {
    component: CNavItem,
    name: 'Client Voucher',
    to: '/client-voucher/list',
    icon: <CImage fluid src={DashboardMenuIcon} className='me-2' />,
    roles: [1, 2]
  },
  {
    component: CNavGroup,
    name: 'Claim History',
    icon: <CImage fluid src={DashboardMenuIcon} className='me-2' />,
    roles: [1, 2],
    items: [
      {
        component: CNavItem,
        name: 'Valid Claim',
        to: '/claim-history/list/valid',
        icon: <CImage fluid src={DashboardMenuIcon} className='me-2' />,
        roles: [1, 2]
      },
      {
        component: CNavItem,
        name: 'Invalid Claim',
        to: '/claim-history/list/invalid',
        icon: <CImage fluid src={DashboardMenuIcon} className='me-2' />,
        roles: [1, 2]
      }
    ]
  },
]

export default _nav
